export const hiSessions = {
  sessions: {
    tabSessions: 'सत्र',
    tabSignature: 'हस्ताक्षर',
    tabMedicationCatalog: 'दवा सूची',
    tabProtocols: 'प्रोटोकॉल',
    tabEducation: 'शिक्षा सामग्री',
    tabScheduling: 'शेड्यूलिंग',
    noSignature: 'कोई हस्ताक्षर सेट नहीं',
    filterToday: 'आज',
    filterTomorrow: 'कल',
    filterThisWeek: 'इस सप्ताह',
    filterAll: 'सभी',
    filterCustom: 'कस्टम सीमा',
    listView: 'सूची दृश्य',
    calendarView: 'कैलेंडर दृश्य',
    allDoctors: 'सभी चिकित्सक',
    sortBy: 'क्रमबद्ध करें:',
    sortDefault: 'डिफ़ॉल्ट (नवीनतम पहले)',
    sortDateNewest: 'अपॉइंटमेंट तारीख — नवीनतम पहले',
    sortDateOldest: 'अपॉइंटमेंट तारीख — सबसे पुरानी पहले',
    sortTimeEarliest: 'अपॉइंटमेंट समय — सबसे पहले',
    sortTimeLatest: 'अपॉइंटमेंट समय — सबसे बाद',
    sortIdLow: 'सत्र ID — कम से अधिक',
    sortIdHigh: 'सत्र ID — अधिक से कम',
    searchPlaceholder: 'रोगी के नाम या फ़ोन से खोजें...',
    bulkUpload: 'थोक अपलोड',
    createNew: 'नया सत्र बनाएँ',
    loading: 'सत्र लोड हो रहे हैं...',
    appointmentsHeading: '{filter} अपॉइंटमेंट',
    appointmentsRange: '{start} - {end} अपॉइंटमेंट',
    emptyTitle: 'कोई {filter} अपॉइंटमेंट नहीं मिला',
    emptySearch: 'आपकी खोज से कोई {filter} अपॉइंटमेंट मेल नहीं खाता।',
    emptyScheduled: '{filter} के लिए कोई अपॉइंटमेंट निर्धारित नहीं है।',
    emptyRange: '{start} - {end} के लिए कोई अपॉइंटमेंट नहीं मिला',
    emptyRangeSearch: 'चयनित तारीख सीमा में आपकी खोज से कोई अपॉइंटमेंट मेल नहीं खाता।',
    emptyAll: 'कोई सत्र उपलब्ध नहीं। शुरू करने के लिए अपना पहला सत्र बनाएँ।',
    emptyRangeScheduled: 'चयनित तारीख सीमा के लिए कोई अपॉइंटमेंट निर्धारित नहीं है।',
    emptyPickRange: 'अपॉइंटमेंट देखने के लिए तारीख सीमा चुनें।',
    showingRange: '{total} में से {start}-{end} दिखाए जा रहे हैं',
    colPatient: 'रोगी का नाम',
    colPatientHint: 'रोगी खोजने के लिए खोज का उपयोग करें',
    colPhone: 'फ़ोन नंबर',
    colDoctor: 'चिकित्सक',
    colNotification: 'सूचना',
    colPreconsult: 'पूर्व-परामर्श',
    colType: 'सत्र प्रकार',
    sent: 'भेजा गया',
    notSent: 'नहीं भेजा गया',
    rowsPerPage: 'प्रति पृष्ठ पंक्तियाँ:',
    statusNotArrived: 'नहीं पहुँचे',
    statusCheckedIn: 'चेक-इन हो गया',
    statusInConsultation: 'परामर्श में',
    statusCompleted: 'सत्र पूर्ण',
    statusCompletedShort: 'पूर्ण',
    statusNoShow: 'अनुपस्थित',
    statusCancelled: 'रद्द',
    createTitle: 'नया सत्र बनाएँ',
    searchMrn: 'MRN से खोजें',
    searchMrnPlaceholder: 'खोजने के लिए MRN के अंतिम 4+ अंक दर्ज करें',
    searching: 'खोज हो रही है...',
    patientName: 'रोगी का नाम *',
    patientNamePlaceholder: 'रोगी का पूरा नाम दर्ज करें',
    phone: 'फ़ोन नंबर *',
    phonePlaceholder: 'फ़ोन नंबर दर्ज करें',
    mrnOptional: 'चिकित्सा रिकॉर्ड संख्या (वैकल्पिक)',
    mrnPlaceholder: 'यदि उपलब्ध हो तो क्लिनिक MRN दर्ज करें',
    dob: 'जन्म तिथि *',
    dobRequired: 'जन्म तिथि आवश्यक है',
    dobMissingOnRecord:
      'इस रोगी रिकॉर्ड में जन्म तिथि नहीं है। सत्र बनाने के लिए इसे जोड़ें।',
    patientMatchHint:
      'मौजूदा रोगियों को देखने के लिए नाम के कम से कम दो अक्षर दर्ज करें।',
    matchingPatients: 'मेल खाने वाले मौजूदा रोगी',
    sameNameWarning:
      'जाँचें: एक से अधिक रिकॉर्ड इस नाम के हैं। चुनने से पहले फ़ोन अंकों या जन्म तिथि से पुष्टि करें।',
    noneOfTheseNewPatient: 'इनमें से कोई नहीं — नए रोगी के रूप में जारी रखें',
    sendLinkHint: 'पूर्व-परामर्श लिंक भेजें',
    resendLinkHint: 'नया पूर्व-परामर्श लिंक भेजें',
    sendLinkTitle: 'पूर्व-परामर्श लिंक भेजें?',
    resendLinkTitle: 'नया पूर्व-परामर्श लिंक भेजें?',
    resendLinkBody: '{name} ({phone}) को WhatsApp द्वारा पूर्व-परामर्श लिंक भेजा जाएगा।',
    resendLinkSupersedes: 'नया लिंक भेजते ही पहले भेजा गया लिंक काम करना बंद कर देगा।',
    resendLinkWindow: 'लिंक मुलाकात के समय से जुड़ा है: यह अपॉइंटमेंट से दो दिन पहले खुलता है और शुरू होने के कुछ घंटे बाद बंद हो जाता है।',
    resendLinkConfirm: 'लिंक भेजें',
    resendLinkSent: '{name} को पूर्व-परामर्श लिंक भेज दिया गया। पहले का कोई भी लिंक अब काम नहीं करेगा।',
    resendLinkAlreadyDone: 'लिंक नहीं भेजा गया: इस रोगी ने इस सत्र के लिए पूर्व-परामर्श पहले ही पूरा कर लिया है।',
    resendLinkFailed: 'पूर्व-परामर्श लिंक नहीं भेजा जा सका।',
    assignDoctor: 'चिकित्सक नियुक्त करें *',
    selectDoctor: 'चिकित्सक चुनें',
    appointmentDate: 'अपॉइंटमेंट तारीख *',
    appointmentTime: 'अपॉइंटमेंट समय *',
    sessionType: 'सत्र प्रकार *',
    typePhysical: 'व्यक्तिगत',
    typeOnline: 'ऑनलाइन',
    practitionerType: 'चिकित्सक प्रकार *',
    patientLanguage: 'रोगी की भाषा',
    rheumatologist: 'रुमेटोलॉजिस्ट',
    dermatologist: 'त्वचा विशेषज्ञ',
    generalPractitioner: 'सामान्य चिकित्सक',
    viewTitle: 'सत्र विवरण देखें',
    viewConfirm: 'सत्र देखें',
    viewSubtitle: 'आप सत्र जानकारी देखने वाले हैं',
    sessionInformation: 'सत्र जानकारी',
    sessionId: 'सत्र ID',
    patient: 'रोगी',
    date: 'तारीख',
    time: 'समय',
    status: 'स्थिति',
    editAppointment: 'अपॉइंटमेंट संपादित करें',
    selectDateRange: 'तारीख सीमा चुनें',
    from: 'से:',
    to: 'तक:',
    bulkTitle: 'थोक अपॉइंटमेंट अपलोड',
    csvRequirements: 'CSV फ़ाइल आवश्यकताएँ:',
    csvNoHeaders: 'फ़ाइल बिना हेडर के CSV प्रारूप (.csv) में होनी चाहिए',
    csvMaxSize: 'अधिकतम फ़ाइल आकार: 5MB',
    dropCsv: 'CSV फ़ाइल चुनने के लिए क्लिक करें या खींचकर छोड़ें',
    maxSizeHint: 'अधिकतम फ़ाइल आकार: 5MB',
    bulkSummary: 'थोक अपलोड सारांश',
    totalProcessed: 'कुल संसाधित',
    successful: 'सफल',
    failed: 'विफल',
    skipped: 'छोड़ा गया',
    ignored: 'अनदेखा',
    issues: 'आए हुए मुद्दे:',
    downloadFailed: 'विफल रिकॉर्ड CSV डाउनलोड करें',
    calToday: 'आज',
    patientUnavailable: 'रोगी उपलब्ध नहीं',
    unassigned: 'अनियुक्त',
    notSet: 'सेट नहीं',
    sessionCalendar: 'सत्र कैलेंडर',
    colAppointmentDate: 'अपॉइंटमेंट तारीख',
    colAppointmentTime: 'अपॉइंटमेंट समय',
    clickToView: 'सत्र विवरण देखने के लिए क्लिक करें',
    editAppointmentHint: 'अपॉइंटमेंट तारीख/समय संपादित करें',
    sessionCount: '{count} सत्र',
    sessionCountPlural: '{count} सत्र',
    weekdayMon: 'सोम',
    weekdayTue: 'मंगल',
    weekdayWed: 'बुध',
    weekdayThu: 'गुरु',
    weekdayFri: 'शुक्र',
    weekdaySat: 'शनि',
    weekdaySun: 'रवि',
    loadFailed: 'सत्र लोड नहीं हो सके। कृपया पुनः प्रयास करें।',
    navigateFailed: 'सत्र पर नहीं जा सके। कृपया पुनः प्रयास करें।',
    appointmentUpdated: 'सत्र #{id} की अपॉइंटमेंट तारीख/समय अपडेट हो गई',
    updateAppointmentFailed: 'अपॉइंटमेंट अपडेट नहीं हो सका। कृपया पुनः प्रयास करें।',
    dateRequired: 'अपॉइंटमेंट तारीख आवश्यक है',
    datePast: 'अपॉइंटमेंट तारीख अतीत में नहीं हो सकती (सिंगापुर समय)',
    timeRequired: 'अपॉइंटमेंट समय आवश्यक है',
    nameRequired: 'रोगी का नाम आवश्यक है',
    nameInvalid: 'कृपया मान्य नाम दर्ज करें (2-50 अक्षर)',
    phoneRequired: 'फ़ोन नंबर आवश्यक है',
    phoneInvalid: 'कृपया मान्य फ़ोन नंबर दर्ज करें',
    doctorRequired: 'नियुक्त करने के लिए चिकित्सक चुनें',
    sessionCreated: 'सत्र सफलतापूर्वक बना! सत्र ID: {id}',
    createFailed: 'सत्र नहीं बन सका। कृपया पुनः प्रयास करें।',
    statusUpdated: 'अपॉइंटमेंट स्थिति "{status}" में अपडेट हुई',
    statusUpdateFailed: 'अपॉइंटमेंट स्थिति अपडेट नहीं हो सकी। कृपया पुनः प्रयास करें।',
    maxRows: 'प्रति पृष्ठ अधिकतम {max} पंक्तियाँ।',
    selectValidCsv: 'कृपया एक मान्य CSV फ़ाइल चुनें',
    fileTooLarge: 'फ़ाइल आकार 5MB से कम होना चाहिए',
    selectCsv: 'कृपया एक CSV फ़ाइल चुनें',
    uploadFailed: 'CSV फ़ाइल अपलोड नहीं हो सकी। कृपया पुनः प्रयास करें।',
    dropValidCsv: 'कृपया एक मान्य CSV फ़ाइल छोड़ें',
    csvColumnOrder: 'आवश्यक स्तंभ क्रम (15 स्तंभ):',
    downloadSample: 'नमूना CSV डाउनलोड करें',
    changeFile: 'फ़ाइल बदलें',
    uploading: 'अपलोड हो रहा है...',
    uploadCsv: 'CSV अपलोड करें',
    failedRecords: 'विफल रिकॉर्ड ({count})',
    skippedRecords: 'छोड़े गए रिकॉर्ड ({count})',
    ignoredRecords: 'अनदेखे रिकॉर्ड ({count})',
    rowLabel: 'पंक्ति {row}',
    unknownError: 'अज्ञात त्रुटि',
    unknownReason: 'अज्ञात कारण',
    moreFailed: '...और {count} और विफल रिकॉर्ड',
    moreSkipped: '...और {count} और छोड़े गए रिकॉर्ड',
    moreIgnored: '...और {count} और अनदेखे रिकॉर्ड',
  },
};
